import { render, staticRenderFns } from "./SubtasksItems.vue?vue&type=template&id=5b5d8112&scoped=true&"
import script from "./SubtasksItems.vue?vue&type=script&lang=js&"
export * from "./SubtasksItems.vue?vue&type=script&lang=js&"
import style0 from "./SubtasksItems.vue?vue&type=style&index=0&id=5b5d8112&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5d8112",
  null
  
)

export default component.exports